import _ = require("underscore");
import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {HttpServiceBase} from "../HttpService/HttpServiceBase";
import {UserService} from "../Authorization/UserService";
import {AuthorizationHelperService} from "../Authorization/AuthorizationHelperService";
import {AppSettings} from "../AppSettings";
import {GlobalService} from "../GlobalService";

@Injectable()
export class GlobalReferenceService extends HttpServiceBase {
    constructor(
        private userService: UserService,
        http: Http,
        globalService: GlobalService,
        authorizationHelperService: AuthorizationHelperService) {
        super(http, globalService, 
            authorizationHelperService, "", 
            AppSettings.systemConfiguration.GlobalReferenceApiAddress);
    }

    getTenants(): Promise<NPS.Common.Types.ITenant[]> {
        return this.get<NPS.Common.Types.ITenant[]>("tenants").then(tenants => {
            var that = this;
            var AvailableTenants: NPS.Common.Types.ITenant[];

            if (!this.userService.user.availableTenants) {
                return;
            }

            var result = _.filter(tenants, tenant => {
                return _.contains(this.userService.user.availableTenants, tenant.id);
            });

            return Promise.resolve(result);
        })
    }
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Authorization/GlobalReferenceService.ts